import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../constants'
import './style.scss'
import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import Signals from '../../../../../../../../../../../components/TableCell/components/Signals'

import hocConnect from './hocConnect'

@injectIntl
@hocConnect
export default class Partners extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        businessPartnersTableChange: PropTypes.func.isRequired,
        customData: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        rows: PropTypes.array,
        sorted: PropTypes.array,
    }

    handleTableChange = (changeData) => {
        const { block, id, level, module, customData, businessPartnersTableChange } = this.props

        businessPartnersTableChange(module, block, id, level, customData, changeData)
    }

    render() {
        const { id, rows, pagination, sorted, isLoading, intl } = this.props

        if (_.isEmpty(rows)) return null

        return (
            <div className={'business-partners-partners'}>
                <div className={'title-container'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.suppliersSubscribers`} />
                </div>
                <div className={'table-container'}>
                    <FilterTable
                        id={`business-partners-partners-table-${id}`}
                        loading={isLoading}
                        columnsDefinition={[
                            {
                                accessor: 'partner',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.company` }),
                                Cell: (value) => (
                                    <div className={'centered-cell'}>
                                        {_.get(value, 'value.countryIso') &&
                                            _.get(value, 'value.countryIso') !== 'CZ' && (
                                                <div
                                                    className={cx(
                                                        'flag-icon',
                                                        `flag-icon-${_.toLower(_.get(value, 'value.countryIso'))}`
                                                    )}
                                                />
                                            )}
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={false}
                                            value={_.get(value, 'value.name', null)}
                                            entId={`${_.get(value, 'value.id', null)}`}
                                        />
                                    </div>
                                ),
                                sortable: true,
                            },
                            {
                                accessor: 'partner.indicators',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.signals` }),
                                Cell: (value) => (
                                    <div className={'centered-cell'}>
                                        <Signals
                                            id={_.get(value, 'original.partner.id', null)}
                                            risk={_.get(value, 'value.risk', 0)}
                                            notice={_.get(value, 'value.notice', 0)}
                                            caution={_.get(value, 'value.caution', 0)}
                                        />
                                    </div>
                                ),
                                width: 160,
                            },
                        ]}
                        data={rows ?? []}
                        settings={{
                            pagination,
                            sorted,
                        }}
                        onTableChange={this.handleTableChange}
                        texts={{
                            pagination: {
                                page: intl.formatMessage({ id: 'global.page' }),
                                from: intl.formatMessage({ id: 'global.of' }),
                                rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                                rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                                all: intl.formatMessage({ id: 'global.all' }),
                            },
                        }}
                    />
                </div>
            </div>
        )
    }
}
